import { Table } from 'docx';
import i18next from 'i18next';
import { fCurrency } from 'src/helpers/formatNumber';
import { fPartResponsabilite } from 'src/helpers/formatValues';
import { simpleVerticalTablePrint } from '../simpleVerticalTablePrint';

export const partResponsabiliteTotalPrint = ({
  total,
  partResponsabilite,
}: {
  total: number;
  partResponsabilite: number;
}): Table => {
  const totalPartResponsabilite = total * partResponsabilite;
  return simpleVerticalTablePrint([
    {
      label: i18next.t('partResponsabilite.tableRowHeader', {
        partResponsabilite: fPartResponsabilite(partResponsabilite * 100),
      }),
      value: fCurrency(totalPartResponsabilite),
      bold: true,
    },
  ]);
};
